/* tslint:disable */
/* eslint-disable */
/**
 * Bookings API
 * Bookings API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetDayAvailability200ResponseValueInner } from './GetDayAvailability200ResponseValueInner';
import {
    GetDayAvailability200ResponseValueInnerFromJSON,
    GetDayAvailability200ResponseValueInnerFromJSONTyped,
    GetDayAvailability200ResponseValueInnerToJSON,
    GetDayAvailability200ResponseValueInnerToJSONTyped,
} from './GetDayAvailability200ResponseValueInner';

/**
 * 
 * @export
 * @interface GetDayAvailabilityWithZoneId200ResponseInner
 */
export interface GetDayAvailabilityWithZoneId200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetDayAvailabilityWithZoneId200ResponseInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetDayAvailabilityWithZoneId200ResponseInner
     */
    name: string;
    /**
     * 
     * @type {Array<GetDayAvailability200ResponseValueInner>}
     * @memberof GetDayAvailabilityWithZoneId200ResponseInner
     */
    slots: Array<GetDayAvailability200ResponseValueInner>;
}

/**
 * Check if a given object implements the GetDayAvailabilityWithZoneId200ResponseInner interface.
 */
export function instanceOfGetDayAvailabilityWithZoneId200ResponseInner(value: object): value is GetDayAvailabilityWithZoneId200ResponseInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('slots' in value) || value['slots'] === undefined) return false;
    return true;
}

export function GetDayAvailabilityWithZoneId200ResponseInnerFromJSON(json: any): GetDayAvailabilityWithZoneId200ResponseInner {
    return GetDayAvailabilityWithZoneId200ResponseInnerFromJSONTyped(json, false);
}

export function GetDayAvailabilityWithZoneId200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDayAvailabilityWithZoneId200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'slots': ((json['slots'] as Array<any>).map(GetDayAvailability200ResponseValueInnerFromJSON)),
    };
}

export function GetDayAvailabilityWithZoneId200ResponseInnerToJSON(json: any): GetDayAvailabilityWithZoneId200ResponseInner {
    return GetDayAvailabilityWithZoneId200ResponseInnerToJSONTyped(json, false);
}

export function GetDayAvailabilityWithZoneId200ResponseInnerToJSONTyped(value?: GetDayAvailabilityWithZoneId200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'slots': ((value['slots'] as Array<any>).map(GetDayAvailability200ResponseValueInnerToJSON)),
    };
}

